<template>
    <modal :printButton="true" :downloadButton="true" :close="closeModal" :printStyle="printStyle" :title="`Проверки ${companyName}`">
        <template slot="modalHeader">
            <h3 class="modal-title"><i class="uk-icon-bolt"></i> Проверки {{ companyName }}</h3>
        </template>
        <div class="modal-content" slot="modalBody">
            <loading v-if="isLoading" />
            <div v-if="!isLoading && inspectionList && inspectionList.length" class="inspection-list">
                <ul class="list">
                    <inspection-info
                        v-for="(e, i) in inspectionList"
                        :key="i"
                        :inspection="e" 
                    />
                </ul>
            </div>
        </div>
        <div v-if="pagination && pagination.pages_count > 1" class="modal-footer" slot="modalFooter">
            <old-pagination :paginationObj="pagination" :getNewContent="paginationCallback" />
        </div>
    </modal>
</template>

<script>
import modal from '@/components/ui/modal.vue'
import loading from '@/components/ui/loading/loading.vue'
import inspectionInfo from '@/components/card/inspections/inspectionInfo.vue'
import oldPagination from '@/components/ui/oldPagination/oldPagination.vue'

export default {
    components: {
        modal,
        loading,
        inspectionInfo,
        oldPagination
    },
    data: () => ({
        printStyle: `
            .item__title { font-size: 20px; }
            .item__number { color: #3498db }
            .item { border-bottom: 1px solid #ddddde; padding: 15px 0; }
            .item__info p { margin: 6px 0 0 0 }
        `
    }),
    computed: {
        companyName() { return this.$store.state?.card?.company?.name_short || this.$store.state?.card?.company?.name_full },
        isLoading() { return this.$store.state?.card?.inspections?.loading },
        inspectionList() { return this.$store.state?.card?.inspections?.inspectionList },
        pagination() { return this.$store.state?.card?.inspections?.pagination },
        currentYear() { return this.$store.state?.card?.inspections?.currentYear }
    },
    methods: {
        closeModal() {
            this.$store.dispatch('card/inspections/closeModal')
        },
        paginationCallback(limit, offset) {
            this.$store.dispatch('card/inspections/getInspectionsByYear', { year: this.currentYear, limit, offset })
        }
    }
}
</script>

<style lang="sass" scoped>
.modal-title
    font-size: 24px
.modal-content
    height: 100%
.modal-footer
    max-width: 80%
    width: 100%
    display: inline-block
    text-align: left
</style>